import { mapMutations } from "vuex";
import moment from "moment";

export default {
  data() {
    return {
      searchParams: this.$route.query,
      modMedKeys: [
        { mmKey: "mrn", newKey: "ptid" },
        { mmKey: "fn", newKey: "ptfname" },
        { mmKey: "ln", newKey: "ptlname" },
        { mmKey: "dob", newKey: "ptdob" }]
    };
  },
  methods: {
    ...mapMutations(["setDelayedStatus", "ssoSearch"]),
    startupTask() {
      return Promise.resolve();
    },
    doSSOSearch() {
      // map all input keys to lower case
      let params = {};
      let keys = Object.keys(this.searchParams);
      let key;
      for (let i = 0; i < keys.length; i++){
        key = keys[i];
        if (this.searchParams[key])
          params[key.toLowerCase()] = decodeURIComponent(this.searchParams[key]);
      }
      this.ssoSearch(params);
      return Promise.resolve();
    },
    complainOnFailure() {
      this.setDelayedStatus({
        message:
          "Unfortunately we could not complete your SSO request. Please try again later.",
        level: "error"
      });
      return Promise.reject();
    },
    continue() {
      this.$router.push("/");
    },
    mapModmedKeys() {
      this.modMedKeys.forEach(({mmKey, newKey}) => {
        if (this.searchParams.hasOwnProperty(mmKey))
          this.searchParams[newKey] = this.searchParams[mmKey];
      });
      return Promise.resolve();
    },
    cleanupModmedDates() {
      if (!this.searchParams) return Promise.resolve();
      if (!this.searchParams.hasOwnProperty("ptdob")) return Promise.resolve();

      let dob = this.searchParams.ptdob;
      let dobMoment = moment(dob, ["YYYY-MM-DD", "MM-DD-YYYY", "MM/DD/YYYY"]);
      if (dobMoment.isValid())
        this.searchParams.ptdob = dobMoment.format("YYYY-MM-DD");

      return Promise.resolve();
    }
  },
  created() {
    return this.startupTask()
      .then(this.mapModmedKeys)
      .then(this.cleanupModmedDates)
      .then(this.doSSOSearch)
      .catch(this.complainOnFailure)
      .finally(this.continue);
  }
};